import { render, staticRenderFns } from "./NotesCardForm.vue?vue&type=template&id=6c7e8e5d&scoped=true&"
import script from "./NotesCardForm.vue?vue&type=script&lang=js&"
export * from "./NotesCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7e8e5d",
  null
  
)

export default component.exports